export const NAV_LINK_CLASS_NAMES = {
   nav: "portal-nav-link",
   navActive: "portal-nav-link--selected"
}
